import { ActivityReport } from 'components/cs-dashboard/activity-report'
import { ContentHistory } from 'components/icons/contentHistory'
import { PanelBarOption } from 'components/panel-bar/types'

import * as React from 'react'
import { SourceCheck } from 'components/cs-dashboard/source-check'
import { UrlRequestHistoryComponent } from 'components/analytics/url-request-history'
import { UrlRequestContentBlockComponent } from '../../components/analytics/url-request-content-block'
import { BulkSourceImport } from '../../components/cs-dashboard/bulk-source-import'
import { AccountFeature } from '../../components/cs-dashboard/account-feature'
import { AppNotification } from 'components/cs-dashboard/app-notification/component';
import {RecommendationsPerformanceComponent} from "../../components/analytics/recommendations";
import { AiReportIcons } from "../../components/icons/aiReports";
import { OutageNotification } from 'components/cs-dashboard/outage-notification';
import { CopyTemplates } from '../../components/copy-templates/component';
import { CloudWatchMonitoring } from '../../components/cs-dashboard/cloudwatch-monitoring';
import { EmailConfigurationsComponent } from '../../components/cs-dashboard/email-configurations';
import { EmailSent } from '../../components/icons/emailSent';
import { BillingSettings } from '../../components/billing-settings/component';
import { SettingsIcon } from '../../components/icons/settings';
import { CommunityConfigurationFeature } from '../../components/cs-dashboard/community-configuration-feature';
import { ChatReplay } from '../../components/cs-dashboard/chat-replay';

const articleActivityIcon = <ContentHistory svgwidth={34.7} svgheight={32.9}/>
const AIReportsIcon = <AiReportIcons svgwidth={29.8} svgheight={29.8} />
const emailConfigIcon = <EmailSent svgwidth={29.8} svgheight={29.8} />
const settingsIcon = <SettingsIcon width={29.8} height={29.8} />

export const allSections: PanelBarOption[] = [
  {
    category: '',
    component: ActivityReport,
    icon: articleActivityIcon,
    name: 'Activity Reports',
    route: 'activity-report',
  },
  {
    category: '',
    component: BulkSourceImport,
    icon: articleActivityIcon,
    name: 'Bulk Source Import',
    route: 'bulk-source-import',
  },
  {
    category: '',
    component: SourceCheck,
    icon: articleActivityIcon,
    name: 'Check Source URL',
    route: 'source-check',
  },
  {
    category: '',
    component: UrlRequestHistoryComponent,
    icon: articleActivityIcon,
    name: 'URL Request History',
    route: 'url-request-history',
  },
  {
    category: '',
    component: UrlRequestContentBlockComponent,
    icon: articleActivityIcon,
    name: 'URL Request Content Block',
    route: 'url-request-content-block',
  },
  {
    category: '',
    component: AccountFeature,
    icon: articleActivityIcon,
    name: 'Account Feature',
    route: 'account-feature',
  },
  {
    category: '',
    component: BillingSettings,
    icon: settingsIcon,
    name: 'Billing Settings',
    route: 'billing-settings',
  },
  {
    category: '',
    component: AppNotification,
    icon: articleActivityIcon,
    name: 'App Notifications',
    route: 'app-notifications',
  },
  {
    category: '',
    component: OutageNotification,
    icon: articleActivityIcon,
    name: 'Outage Notification',
    route: 'outage-notification',
  },
  {
    category: '',
    component: CopyTemplates,
    icon: articleActivityIcon,
    name: 'Copy Templates',
    route: 'copy-templates',
  },
  {
    category: '',
    component: RecommendationsPerformanceComponent,
    icon: AIReportsIcon,
    name: 'Recommendation Performance',
    route: 'recommendation-performance',
  },
  {
    category: '',
    component: CloudWatchMonitoring,
    icon: AIReportsIcon,
    name: 'Error Monitoring',
    route: 'error-monitoring',
  },
  {
    category: '',
    component: EmailConfigurationsComponent,
    icon: emailConfigIcon,
    name: 'Email Configurations',
    route: 'email-configurations',
  },
  {
    category: '',
    component: CommunityConfigurationFeature,
    icon: settingsIcon,
    name: 'Community Configuration',
    route: 'community-configuration',
  },
  {
    category: '',
    component: ChatReplay,
    icon: AIReportsIcon,
    name: 'Chat Session Replay',
    route: 'chat-replay',
  }
]

export const sections = (
  isSuperUser: boolean,
) => {
  return allSections.filter((item) => {
    return isSuperUser
  })
}

export const RETRY_LIMIT = 2
export const RETRY_WAIT_TIME = 5000

export const ACTIVE_COMMUNITY_NOT_FOUND_ERROR = 'Something went wrong. Active community doesn\'t found'
